import React, { Fragment } from 'react';

export const SelectClearIndicator = () => <Fragment />;

export const SelectClearIndicatorStyles = () => ({});
